import { WhiteBox, FoodsBadge, FoodsIllustrations } from "@foodpilot/foods";
import { Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TargetOverview } from "src/api/client-api/company/overview/useOrganizationOverviewOneSsq.tsx";

const SECTOR_COLOR_INDEX = 11;

type SectorTargetProps = {
    target: TargetOverview;
};
export const SectorTarget = (props: SectorTargetProps) => {
    const { target } = props;
    const { t } = useTranslation();
    const theme = useTheme();

    const datavizColors = theme.custom.dataviz.colorsWithExtra[SECTOR_COLOR_INDEX];
    return (
        <WhiteBox border={`2px solid ${datavizColors.main}`}>
            <Stack padding={theme.spacing(3)} gap={theme.spacing(3)} height={"100%"}>
                <Stack flexDirection={"row"} gap={theme.spacing(2)} alignItems={"center"} height={"100%"}>
                    <FoodsBadge
                        size={8}
                        icon="target"
                        boxProps={{
                            sx: {
                                color: datavizColors.variant[700],
                                backgroundColor: datavizColors.variant[100],
                                borderRadius: "8px",
                            },
                        }}
                    />
                    <Typography variant="h2">{target.label}</Typography>
                </Stack>
                <WhiteBox padding={theme.spacing(3)}>
                    <Stack gap={theme.spacing(4)}>
                        <Stack gap={theme.spacing(2)} justifyContent={"center"} alignItems={"start"}>
                            <FoodsIllustrations illustration="informations" variant={`dataviz-${SECTOR_COLOR_INDEX}`} />
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    fontSize: "14px",
                                    lineHeight: "1.5em",
                                    color: "#393A36",
                                }}
                            >
                                {t("understand_my_sectoral_target", "Understand my target")}
                            </Typography>
                            <Typography
                                dangerouslySetInnerHTML={{ __html: target.description }}
                                sx={(theme) => {
                                    return {
                                        "& a": {
                                            color: theme.palette.primary.main,
                                        },
                                    };
                                }}
                            />
                        </Stack>
                    </Stack>
                </WhiteBox>
            </Stack>
        </WhiteBox>
    );
};
